import React from 'react'
import { injectIntl } from 'react-intl'
import Geosuggest from 'react-geosuggest'
import 'react-geosuggest/module/geosuggest.css'

import { AppContext } from 'src/AppContext'
import { fetchAddress } from 'src/lib/geocoder'
import { trackAmplitude } from 'src/lib/analytics'

import LocationIcon from '@uniiverse/library/assets/icons/location.svg'
import { TextInput } from '../text-input/index'

import locale from './locale'
import style from './index.css'
// eslint-disable-next-line css-modules/no-unused-class
import textInputStyle from '../text-input/index.css'

class LocationInputComponent extends React.Component {
  constructor(props) {
    super(props)

    this.geosuggest = React.createRef()

    this.state = {
      showLocationIcon: true,
    }
  }

  async componentDidMount() {
    if (navigator.permissions) {
      const geoPermission = await navigator.permissions.query({ name: 'geolocation' })
      if (geoPermission.state === 'denied') this.setState({ showLocationIcon: false })
    }
  }

  onSuggestSelect = (suggest) => {
    if (!suggest) return

    this.props.changeLocation({
      lat: suggest.location.lat,
      lon: suggest.location.lng,
      locationQuery: suggest.label,
    })
    trackAmplitude(
      'Change Location',
      { cityName: suggest.label, ref: this.props.referral, detected: false },
      this.props.viewer,
    )
  }

  getCurrentLocation = async () => {
    const geoSuccess = (position) => {
      const lat = position.coords.latitude
      const lon = position.coords.longitude
      fetchAddress(
        lat,
        lon,
        ({ cityName }) => {
          this.props.changeLocation({ lat, lon, locationQuery: cityName })
          trackAmplitude('Change Location', { cityName, ref: this.props.referral, detected: true }, this.props.viewer)
        },
        (error) => {
          console.log(error) // eslint-disable-line no-console
        },
      )
    }
    const geoFail = (error) => {
      console.warn(error) // eslint-disable-line no-console
      this.setState({ showLocationIcon: false })
      trackAmplitude('Block Browser Location Detection', { ref: this.props.referral }, this.props.viewer)
    }
    await navigator.geolocation.getCurrentPosition(geoSuccess, geoFail)
  }

  clearText = ({ target: { value } }) => {
    this.props.onChange(value)
    this.geosuggest.current.focus()
  }

  render() {
    const {
      className,
      inputClassName,
      value,
      withClearIcon,
      intl: { formatMessage },
    } = this.props

    const icon =
      this.state.showLocationIcon ?
        <LocationIcon onClick={this.getCurrentLocation} className={style.locationIcon} />
        :
        null

    const fullInputClassName = [
      textInputStyle.input,
      this.state.showLocationIcon ? textInputStyle.inputWithIcon : '',
      inputClassName || '',
    ].join(' ')

    return (
      <AppContext.Consumer>
        {({ googleMapsLoaded }) => (
          <TextInput
            icon={icon}
            withClearIcon={withClearIcon}
            className={className}
            highlightedIcon
            input={
              googleMapsLoaded ?
                <Geosuggest
                  ref={this.geosuggest}
                  initialValue={value}
                  className={style.container}
                  placeholder={formatMessage(locale.placeholder)}
                  inputClassName={fullInputClassName}
                  onSuggestSelect={this.onSuggestSelect}
                  types={['(cities)']}
                  placeDetailFields={['address_components']}
                  onChange={this.props.onChange}
                />
                :
                <TextInput
                  className={style.container}
                  inputProps={{
                    placeholder: formatMessage(locale.placeholder),
                    className: fullInputClassName,
                  }}
                />
            }
            inputProps={{
              value: this.props.value,
              onChange: this.clearText,
            }}
          />
        )}
      </AppContext.Consumer>
    )
  }
}

export const LocationInput = injectIntl(LocationInputComponent)
